export default {
  home: "/",
  notFound: "/not-found",
  hangout: "/hangout",
  profile: "/profile",
  individualSettings: "/account/settings",
  settings: "/settings",
  myTasks: "/my-tasks",
  myJourneys: "/my-journeys",
  newHirePortal: "/my-onboarding",
  newHireTasks: "/my-onboarding/tasks",
  newHireSchedule: "/my-onboarding/schedule",
  showUser: "/users/:id",
  tasks: {
    index: "/tasks",
    show: "/tasks/:id",
  },
  formResponse: "/form/:taskId",
  formShare: "/forms/:uuid",
  prebuilt: {
    paths: {
      show: "/prebuilt/paths/:id",
    },
    emailTemplates: {
      show: "/prebuilt/templates/emails/:id",
    },
    messageTemplates: {
      show: "/prebuilt/templates/messages/:id",
    },
    taskTemplates: {
      show: "/prebuilt/templates/tasks/:id",
    },
  },
  paths: {
    index: "/paths",
    show: "/paths/:id",
    preview: "/paths/preview",
  },
  emails: {
    index: "/emails",
    show: "/emails/:id",
  },
  messages: {
    index: "/messages",
    show: "/messages/:id",
  },
  meetings: {
    index: "/meetings",
    show: "/meetings/:id",
  },
  checkpoints: {
    show: "/checkpoints/:id",
  },
  meetingEvents: {
    index: "/meeting-events",
    show: "/meeting-events/:id",
  },
};
